<template>
    <div>
        <app-header messages="我" detail="常见问题" pathName="/person/me" pathTo="/person/commonproblem"></app-header>
        <!--shopcart-->
        <div class="w">
            <div class="wb">
                <div class="news_show bg_w_s">
                    <h1>常见问题</h1>
                    <div class="news_show_l">
                        <p><strong>关于物流</strong></p>
                        <p>甲方将租赁物通过物流运送到乙方指定地点时，即视为乙方已经接受租赁物并验收完毕。</p>
                        <p><strong>关于发票</strong></p>
                        <p>承租方已支付的每一笔租金款项，3-5个工作日后可以在租罗记(www.zuluoji.com)账户中单独或汇总提交开发票意向，租罗记在收到开发票意向后的5-7个工作日内向承租方开具并递送合格的发票。</p>
                        <!-- <p><strong>关于版权</strong></p>
                        <p>租罗记出租的租赁设备内，所有预装软件皆为正版版权;关于软件技术和售后维护，皆可咨询软件生产厂商。</p> -->
                        <p><strong>关于售后(维修及保养)</strong></p>
                        <p>若无外界因素条件影响下，租赁期间，电脑出现故障无法正常使用时，甲方应在接到通知后24个小时内响应，并提供备用租赁设备，适用产品：租罗记网站展示的：台式电脑、笔记本电脑、一体机电脑等。</p>
                        <p><strong>关于服务时间</strong></p>
                        <p>服务时间：09:30-18:00 客服电话：400-107-2600</p>
                    </div>
                    <Right></Right>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <!--shopcart end-->

        <app-footer></app-footer>
    </div>
</template>
<script>
    import AppHeader from '../../components/common/Header.vue'
    import AppFooter from '../../components/common/Footer.vue'

    import Right from '../../components/common/Right.vue'
    export default {
        name: "commonproblem",
        props:['messages','detail'],
        components: {
            AppHeader,
            AppFooter,

            Right
        }
    }
</script>



// WEBPACK FOOTER //
// src/center/person/commonproblem.vue